import React, { useState, useEffect } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ExperienceSection } from "./components/ExperienceSection";
import { ProductsSection } from "./components/ProductsSection";
import { SupplementsSection } from "./components/SupplementsSection";
import { MesoMedicsSection } from "./components/MesoMedicsSection";
import { SFXAcademySection } from "./components/SFXAcademySection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { getTranslation } from "./mock";

function App() {
  const [language, setLanguage] = useState('es');
  const [t, setT] = useState(getTranslation('es'));

  useEffect(() => {
    setT(getTranslation(language));
  }, [language]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Header 
        language={language} 
        setLanguage={setLanguage} 
        t={t}
        scrollToSection={scrollToSection}
      />
      <main>
        <HeroSection t={t} scrollToSection={scrollToSection} />
        <ExperienceSection t={t} />
        <ProductsSection t={t} />
        <SupplementsSection t={t} />
        <MesoMedicsSection t={t} />
        <SFXAcademySection t={t} />
        <ContactSection t={t} />
      </main>
      <Footer t={t} scrollToSection={scrollToSection} />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
